import { ReactNode } from 'react';
import { Layout } from '../../../../../../components/Layout'; // Import the Layout component

interface Props {
  children: ReactNode;
  width: string;
}

const TOP_BAR_HEIGHT = 64;
const BOTTOM_BAR_HEIGHT = 72;

export const SubmissionFlowLayout: React.FC<Props> = ({ children, width }) => {
  return (
    <Layout
      width={width}
      paddingY={3}
      minHeight={`calc(100vh - ${TOP_BAR_HEIGHT + BOTTOM_BAR_HEIGHT}px)`} // Pass minHeight
    >
      {children}
    </Layout>
  );
};
